import React from 'react';

import { graphql } from 'gatsby';

import { Button, Grid2 as Grid } from '@mui/material';

import { ResponsiveGrid } from '@mewa/ui';

import { useConversionButtonLabel } from '../../../a-b-testing/cta-label-experiment';
import { NavigationData } from '../../../components/header/types';
import { PageHeadlineCTAProps } from '../../../components/page-headline-wrapper';
import { PageHeadlineWrapper } from '../../../components/page-headline-wrapper';
import { SapFormData } from '../../dynamic-content-page/content-components/sap-form';
import { PossibleStageComponents } from './stage-section';

export const PageHeadlineFragment = graphql`
  fragment PageHeadlineFragment on STRAPI__COMPONENT_SHARED_PAGE_HEADLINE {
    strapi_component
    title: Title
    subtitle: Subtitle
    showCTA: ShowCTA
  }
`;

export const componentName = 'shared.page-headline';

export type PageHeadlineData = {
  title: string;
  subtitle: string;
  showCTA: boolean | null;
  strapi_component: typeof componentName;
};

export const isPageHeadline = (
  component: PossibleStageComponents,
): component is PageHeadlineData => {
  return component.strapi_component === componentName;
};

export const StrapiPageHeadline = ({
  data,
  sapForm,
  langPrefix,
  navigationData,
}: {
  data: PageHeadlineData;
  sapForm?: SapFormData | undefined;
  navigationData: NavigationData;
  langPrefix: string;
}) => {
  const { ctaLabel } = useConversionButtonLabel({
    translations: navigationData.headerAndFooterTranslations,
  });

  const cta: PageHeadlineCTAProps | undefined =
    data.showCTA && !sapForm
      ? {
          label: ctaLabel,
          link: `${langPrefix}/${navigationData.navigationLinks.conversion.contact.slug}`,
        }
      : undefined;

  return (
    <>
      <PageHeadlineWrapper
        {...data}
        cta={cta}
        sx={{
          paddingBottom:
            sapForm !== null
              ? [
                  // calc(paddingSize, buttonSize)
                  'calc(32px + 52px)',
                  'calc(56px + 57px)',
                  null,
                  'calc(64px + 57px)',
                ]
              : [],
        }}
      />

      {sapForm ? (
        <ResponsiveGrid
          sx={{
            transform: 'translateY(-100%)',
            marginTop: ['-35px', '-200px'],
            marginBottom: '40px',
          }}
        >
          <Grid>
            <Button
              onClick={() => {
                document.getElementById('sapForm')?.scrollIntoView({
                  behavior: 'smooth',
                });
              }}
              variant="outlined"
            >
              {sapForm.scrollToFormButtonLabel}
            </Button>
          </Grid>
        </ResponsiveGrid>
      ) : null}
    </>
  );
};
